"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function LikeTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'like',
        theme: 'twotone',
        nameWithTheme: 'like-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4c20.4-9.2 33.6-29.4 33.6-51.8 0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19c12.5-10.8 19.6-26.5 19.6-43 0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19c12.5-10.8 19.6-26.5 19.6-43 0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19c12.5-10.8 19.6-26.5 19.6-43 0-19.1-11-37.5-28.8-48.4z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4-20.5-21.6-48.2-33.4-77.9-33.4-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5c4.6 8.4 6.9 17.6 6.9 27.3 0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4c4.6 8.4 6.9 17.6 6.9 27.3 0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4c4.6 8.4 6.9 17.6 6.9 27.3 0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5 5.3-18.9 22.6-32.2 42.2-32.3 7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'like-twotone';
var LikeTwoTone = temp;
exports.default = LikeTwoTone;



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/@ant-design/icons/lib/twotone/LikeTwoTone.js
// module id = 1156
// module chunks = 0